'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoreFull = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (process.env.BROWSER) {
  require('./MoreFull.css');
}

var MoreFull = function (_Component) {
  _inherits(MoreFull, _Component);

  function MoreFull(props, context) {
    _classCallCheck(this, MoreFull);

    return _possibleConstructorReturn(this, (MoreFull.__proto__ || Object.getPrototypeOf(MoreFull)).call(this, props, context));
  }

  _createClass(MoreFull, [{
    key: 'render',
    value: function render() {
      var loadMore = this.props.loadMore;


      return _react2.default.createElement(
        'div',
        { className: 'moreFull-articles', onClick: loadMore },
        '更多文章'
      );
    }
  }]);

  return MoreFull;
}(_react.Component);

exports.default = MoreFull;
exports.MoreFull = MoreFull;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MoreFull.js
 ** module id = 807
 ** module chunks = 0
 **/